/*
 * @Author: changcheng
 * @LastEditTime: 2023-07-27 11:39:54
 */
import { useEffect, useState } from "react";
import axios from "@/axios/axios";
export default function NormalQuestion() {
  const [questionMessage, setQuestionMessage] = useState("");
  /**
   * 获取后台配置文案信息
   */
  const getContentInfo = async () => {
    const {
      data: { questionMessage },
    } = await axios.post(" /shop/front/ce/item/content/info", {});
    setQuestionMessage(questionMessage);
  };
  useEffect(() => {
    getContentInfo();
  }, []);
  return (
    <div style={{ background: "#fff" }}>
      <h2>常见问题</h2>
      <div
        dangerouslySetInnerHTML={{
          __html: questionMessage,
        }}
      ></div>
    </div>
  );
}
